import { props, generateID, saveAndNavigate } from './syllabus-block-utils';
import Block from './block';

export default {
  props,

  template: '#course-promo-block-template',

  components: {
    Block
  },

  data() {
    return Object.assign(
      {
        title: '',
        showOnPublicSyllabus: true,
        promo: this.$root.course.course_promo_video,
      },
      this.rootData
    );
  },

  watch: {
    dataForSave() {
      this.$emit('block-update', this.dataForSave);
    },
  },

  computed: {
    isEmpty() {
      return !this.hasPromoVideo;
    },

    dataForSave() {
      return {
        uuid: this.uuid,
        data: {
          title: this.title,
          showOnPublicSyllabus: this.showOnPublicSyllabus
        }
      };
    },

    videoPlayerID() {
      return generateID('promo-video');
    },

    promoThumb() {
      return this.promo && this.promo.thumb_url;
    },

    hasPromoVideo() {
      return !_.isEmpty(this.promo && this.promo.h264_360_url);
    }
  },

  methods: {
    initVideoPlayer() {
      this.videoPlayer = new Kadenze.VideoPlayer(
        $(this.$refs.videoPlayerEle),
        this.promo,
        'vjs-instructor-skin'
      );
    },

    navigateToSettings() {
      let opts = {
        title: 'Are you sure you want to leave?',
        body: `You are about to leave the Syllabus Creator to edit your
        course video, any changes will be saved`,
        cancel_btn_text: 'Return To Builder',
        ok_btn_text: 'Save & Continue'
      };
      const path = Kadenze.Routes.course_settings_path(this.$root.course.id) + '#course_info';

      Kadenze.UIUtil.confirmAction(
        opts.body, () => {
          this.$root.save(() => window.location = path);
        }, null, opts
      );   
    }
  },

  mounted() {
    this.initVideoPlayer();
  },
};
